import { IItem } from "src/domain/entities"
import { itemListApi } from "../../api/item/itemListApi"

type PayloadShape = Parameters<typeof itemListApi>[0]

export async function itemListService(payload: PayloadShape, token?: null | string) {
	const item = await itemListApi(payload, token)
	return item as NonNullable<IItem[]>
}
